import { Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import InputTableLayout, { BigTitleAndRightLayoutInputTableNewCustomer, InputTableLayoutNew, InputTableLayoutProps } from '../../../../baseComponents/TwinTable/InputTableLayout'
import { ITDisplayPrice, ITDisplayPriceNotRounded, ITDisplayFinalPrice, ITDisplayEditFinalPrice, ITDisplayInitialPrice, ITDisplayImage, ITBooleanRender, ITDeleteRowSell, OrderDisplayEditFinalPriceBase, OrderDisplayInitiaPrice } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITInputSelectAccounts, ITInputSelectWithSeachBar, ITInputSelectWarehouses, ITOrderWarehouse, ITInputQuantityRefund } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { InputTableFooterFullProps } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { DictionaryComponents } from '../../../../utils/globals/types'
import withLoading from '../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { CostSellPayload } from '../../../../utils/reducers/company/costsSell'
import { ShippingCompanyPayload } from '../../../../utils/reducers/company/shippingCompanies'
import { getAllCostsSell, getUserPermissions } from '../../../../utils/reducers/getters'
import { OrderRectangularInputSmall, OrderEditableText, OrderInputPrice, OrderSaveRemainingProduct, ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderInputQuantity, OrderInputQuantity2, OrderInputDiscount, OrderInputCalendar, OrderRefundProduct, OrderInputPercentage, OrderEditableName } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputName, OrderSearchProductInputReferenceAndName, OrderSearchProductInputCreate } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderEditAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditAddonProduct'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import OrderUniqueNumberProduct, { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import OrderTotal, { OrderTotalNew } from '../OrderLayout/OrderTotal'
import ModalsOrderSellLayout from './ModalsOrderSellLayout'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import OrderSyncProductPrice from '../OrderLayout/OrderTable/TableComponents/OrderSyncProductPrice'
import { useOrderLayoutTableLogic } from '../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import OrderProductWorkSheetStatus from '../OrderLayout/OrderTable/TableComponents/OrderProductWorkSheetStatus'
import { SellRefundCheckbox, SellSelectedCheckbox } from '../../../sells/components'
import OrderChangePackUnit from '../OrderLayout/OrderTable/TableComponents/OrdeChangePackUnit'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'
import { FooterRowSellShortComponent } from '../OrderLayout/OrderTable/TableComponents/OrderTotal/Components/HeaderOrderTotal'
import { FooterConfigSellShippingComponent } from '../OrderLayout/OrderTotal/FooterOrderTotal/Components/FooterOrderLeftComponent'
import useOrderCalculateTotals from '../../../../utils/hooks/orders/useOrderCalculateTotals'

interface OrderSellLayoutProps extends InputTableLayoutProps { }

const OrderSellLayout: React.FC<OrderSellLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={InputTableLayoutRenderDefault} NewComponent={InputTableLayoutRenderNew} {...rest} />
    )
}

const InputTableLayoutRenderDefault: React.FC<OrderSellLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayout hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildren} {...rest} components={sellOrderLayoutComponents} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer}/>
    )
}

const InputTableLayoutRenderNew: React.FC<OrderSellLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayoutNew hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildrenNew} {...rest} components={sellOrderLayoutComponents} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer}/>
    )
}

const OrderTableChildren: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotal costs={costs || {}} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, totalsOrderTableData,  ...rest }} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} totalsOrderTableData={totalsOrderTableData} {...rest} />
        </Fragment>
    )
}

const OrderTableChildrenNew: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotalNew costs={costs || {}} FooterOrderRowShortComponent={FooterRowSellShortComponent} FooterOrderLeftConfigComponent={FooterConfigSellShippingComponent} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} totalsOrderTableData={totalsOrderTableData} {...rest} />
        </Fragment>
    )
}

export const sellOrderLayoutComponents: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    ITInputNumeric: OrderInputPrice,
    ITInputPercentage: OrderInputPercentage,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    OrderSaveRemainingProduct: OrderSaveRemainingProduct,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayEditFinalPriceBase: OrderDisplayEditFinalPriceBase,
    ITDisplayInitialPrice: ITDisplayInitialPrice,
    ITDisplayInitialPriceBase: OrderDisplayInitiaPrice,
    OrderEditProduct: OrderEditProduct,
    OrderSyncProductPrice: OrderSyncProductPrice,
    OrderEditAddonProduct: OrderEditAddonProduct,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectAccounts: ITInputSelectAccounts,
    ITInputSelectWithSeachBar: ITInputSelectWithSeachBar,
    OrderUniqueNumberProduct: OrderUniqueNumberProduct,
    OrderUniqueNumberProductReadOnly: OrderUniqueNumberProductReadOnly,
    ITInputSelectWarehouses: ITInputSelectWarehouses,
    DeleteComponent: ITDeleteRowSell,
    ITOrderWarehouse: ITOrderWarehouse,
    OrderProductWorkSheetStatus,
    CheckboxComponent: SellSelectedCheckbox,
    SellRefundCheckbox,
    OrderChangePackUnit,
    OrderRefundProduct,
    ITInputQuantityRefund,
    OrderPrintTags
}

const orderSellLayoutDispatch = {
    setShippingCompanies: (payload: ShippingCompanyPayload) => ({ type: 'CHANGE_SHIPPINGCOMPANY', payload }),
    setCostsSell: (payload: CostSellPayload) => ({ type: 'CHANGE_COSTSELL', payload }),
}

export type ReduxOrderSellLayout = ConnectedProps<typeof orderSellLayoutConnect>
const mapOrderSellLayoutConnector = (state: AllReduxPayloads) => ({ shippingCompanies: state.shippingCompanies, costsSell: state.costsSell })
const orderSellLayoutConnect = connect(mapOrderSellLayoutConnector, orderSellLayoutDispatch)
const orderSellLayoutConnectLoading = withLoading(OrderSellLayout, [{ fetchUrl: '/api/app/config/shipping/shippingCompany/getAllShippingCompaniesComplete', propName: 'shippingCompanies', setFunctionName: 'setShippingCompanies' }, { fetchUrl: '/api/app/config/cost/costSell/getAllCostSells', propName: 'costsSell', setFunctionName: 'setCostsSell' }])
const OrderSellLayoutConnect = orderSellLayoutConnect(orderSellLayoutConnectLoading)


export default OrderSellLayoutConnect